// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'  
import Vue from 'vue'
import App from './App'
import router from './router'

import {langdetector} from '@/langdetector';

//SET IDIOMA
localStorage.setItem('language', langdetector());

//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
//.AXIOS

//VEE-VALIDATE
import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate);
//.VEE-VALIDATE


//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: store.state.language, 
	messages,
});
//.IDIOMAS

import AOS from 'aos'
import 'aos/dist/aos.css'

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

// Sentry.init({
// 	dsn: 'https://d46a453fdb1e4db1b05748f87526ed9f@o393426.ingest.sentry.io/5242538',
// 	integrations: [new VueIntegration({Vue, attachProps: true, logErrors:true})],
// });

// import VueFacebookPixel from 'vue-analytics-facebook-pixel'
 
// Vue.use(VueFacebookPixel)

// Vue.analytics.fbq.init('1694163357408122', {
// 	em: 'info@doubledot.es'
//   })

Vue.config.productionTip = false


Vue.filter('comma', function (value) {
	return String(value).replace(".",",").substr(0,6)
})

Vue.filter('commadouble', function (value) {
	return String(value).replace(".",",").substr(0,4)
})



new Vue({
	el: '#app',
	created () {
		AOS.init({
			easing: 'ease-in-out',
		})
	},
	router,
	i18n,
	store,
	VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js